// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sq-1";
export var stateContainer = "_sq-0";